import React from 'react';
import { SiteHeader, SiteFooter } from './Layout';
import './App.css';

const SPROUT_URL = 'https://wellness.codethatdown.com';

const sproutPhoneShots = [
  { file: 'narrow-today', caption: 'Goals, schedule and calories for the day' },
  { file: 'narrow-chat', caption: 'Chat to log meals, add tasks and start goals' },
  { file: 'narrow-progress', caption: 'Levels, streaks, mood and weight trends' },
];

// Light screenshots are the ones Sprout publishes; dark versions live in public/sprout.
function Screenshot({ file, alt, width, height }) {
  return (
    <picture>
      <source
        srcSet={`${process.env.PUBLIC_URL}/sprout/${file}-dark.webp`}
        media="(prefers-color-scheme: dark)"
      />
      <img
        src={`${SPROUT_URL}/screenshots/${file}.webp`}
        alt={alt}
        width={width}
        height={height}
        loading="lazy"
      />
    </picture>
  );
}

function HomePage() {
  return (
    <div className="page">
      <SiteHeader />

      <main>
        <section className="intro container">
          <h1 className="intro-title">
             Building what helps people.
          </h1>
          <p className="intro-lede">
            Based in Atlanta, GA
          </p>
        </section>

        <section className="work container" aria-labelledby="work-title">
          <h2 id="work-title" className="eyebrow">Selected work</h2>

          <article className="project">
            <div className="project-header">
              <div>
                <h3 className="project-title">Sprout</h3>
                <p className="project-summary">
                  A private wellness assistant that helps you build daily habits. It plans
                  your goals around your day, runs focus sessions, logs meals, and tracks
                  mood and progress. Data stays on your device unless you choose to sync.
                </p>
              </div>
              <a className="project-link" href={SPROUT_URL} target="_blank" rel="noopener noreferrer">
                wellness.codethatdown.com <span aria-hidden="true">↗</span>
              </a>
            </div>

            <figure className="shot shot-wide">
              <Screenshot
                file="wide-today"
                alt="Sprout on desktop: the chat sidebar beside the Today view with the day's schedule, goals and calories"
                width="1280"
                height="800"
              />
            </figure>

            <ul className="shot-row">
              {sproutPhoneShots.map((shot) => (
                <li key={shot.file}>
                  <figure className="shot shot-phone">
                    <Screenshot
                      file={shot.file}
                      alt={`Sprout on a phone: ${shot.caption.toLowerCase()}`}
                      width="824"
                      height="1784"
                    />
                    <figcaption>{shot.caption}</figcaption>
                  </figure>
                </li>
              ))}
            </ul>
          </article>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}

export default HomePage;
